<template>
  <div id="popup-wrap">
    <van-popup v-model="isWithdraw" class="popup-wrap">
      <div class="popup-box">
        <div class="popup-header">
          <div class="popup-title">提现</div>
          <img src="../../../../../assets/img/h5/official/home_icon_cross.png" @click="handelCancel"/>
        </div>
        <div class="popup-content">
<!--          <div class="withdraw-tips">-->
<!--            提示：提现收取1%手续费，实际打款金额为提现金额的99%-->
<!--          </div>-->
          <div class="">
            <div class="label-title padding-t-15 padding-b-8">真实姓名</div>
            <div class="input-box">
              <input type="text" class="padding-10-12" v-model="withdrawForm.name" placeholder="请输入真实姓名" >
            </div>
          </div>
          <div class="">
            <div class="label-title padding-t-15 padding-b-8">支付宝账号</div>
            <div class="input-box">
              <input type="text" class="padding-10-12" v-model="withdrawForm.alipayAccount" placeholder="请输入支付宝账号" >
            </div>
          </div>
          <div class="">
            <div class="label-title padding-t-15 padding-b-8">提现金额(元)</div>
            <div class="input-box">
              <input type="text" class="padding-10-12" v-model="withdrawForm.withdraw" placeholder="请输入提现金额">
            </div>
            <div class="can-withdraw">最大可提现金额：<span>{{maxCanWithdraw}}</span>元</div>
          </div>
        </div>
        <div class="btn-wrap">
          <div class="sure-btn" @click="handelSubmit">提交</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getPlatformUuid } from '@/utils/auth'
import { getUserMaxCanWithdraw } from '@/api/withdraw'
import  withdraw from '@/javaApi/withdraw.js'
const withdrawModel = new withdraw()
export default {
  name: "Withdraw",
  props: {
    /* info: {
      type: Object,
      default: {}
    }, */
  },
  created() {
    //console.log(this.info)
  },
  data: function () {
    return {
      isWithdraw: false,
      withdrawForm: {
        name: '',
        alipayAccount: '',
        withdraw: ''
      },
      loading:false,
      ruleValidate: {},
      maxCanWithdraw: 0,
      spinShow:true
    }
  },
  computed:{
    platformUuid(){
      return getPlatformUuid()
    }
  },
  methods: {
    init: function (money) {
      this.maxCanWithdraw = money
      this.queryBasicInfo()
      this.isWithdraw = true
    },
    handelCancel: function () {
      this.isWithdraw = false
    },
    queryBasicInfo(){
      let param = {
        platformUuid:this.platformUuid
      }
      let that = this
      withdrawModel.getWithdrawInfo(param).then(response=>{
        that.spinShow = false
        let res = response.data
        if(res.code == 200){
          if(res.data){
            let list = res.data
            if(list){
              this.withdrawForm.name= list.name?list.name:''
              this.withdrawForm.alipayAccount = list.alipayAccount?list.alipayAccount:''
            }
          }
        }else{
          let message = res.message?res.message:'系统异常请稍后再试试'
          that.$Message.error(message)
        }
      }).catch(error=>{
        console.log(error)
        that.spinShow = false
        if(error != 'token invalid'){
          that.$Message.error('系统异常请稍后再试！')
        }
      })
    },
    handelSubmit: function () {
      let that = this
      if(this.loading){
        return
      }
      if(!this.withdrawForm.name){
        this.$Message.error('请填写真实姓名')
        return
      }
      if(!this.withdrawForm.alipayAccount){
        this.$Message.error('请填写支付宝账号')
        return
      }
      let alipayReg =  /^(?:1[3-9]\d{9}|[a-zA-Z\d._-]*\@[a-zA-Z\d.-]{1,10}\.[a-zA-Z\d]{1,20})$/
      if(!alipayReg.test(this.withdrawForm.alipayAccount)){
        this.$Message.error('请填写正确的支付宝账号格式！')
        return
      }
      if(!this.withdrawForm.withdraw){
        this.$Message.error('请填写提现金额')
        return
      }
      let money = parseFloat(this.withdrawForm.withdraw)?parseFloat(this.withdrawForm.withdraw):0
      if(money<=0){
        this.$Message.error('提现金额请填写大于0的数字')
        return
      }
      if(money>this.maxCanWithdraw){
        this.$Message.error('提现金额超出最大范围')
        return
      }
      this.loading = true
      this.withdrawForm.platformUuid = this.platformUuid
      withdrawModel.insertWithdrawRecord(this.withdrawForm).then(response => {
        that.loading = false
        let res = response.data
        if(res.code == 200){
          that.$Message.success(res.message)
          that.handelCancel();
        }else{
          let message = res.message?res.message:'系统异常请稍后再试'
          that.$Message.error(message)
        }
      }).catch(error => {
        that.loading = false
        that.$Message.error('系统异常请稍后再试')
        console.log(error)
      })
    }
  }
}
</script>


<style lang="less" scoped>
.withdraw-tips{
  font-size: 12px;
  color: #FF4F76;
  margin-top: 1px;
}
.label-title{
  font-size: 13px;
  color: #666666;
}
.input-box{
  background: #FAFAFA;
  border-radius: 1px;
  input{
    font-size: 14px;
    color: #222222;
    letter-spacing: 0;
    background: #FAFAFA;
  }
  input::-webkit-input-placeholder{
    color: #C1C1C1;
  }
}
.code-box{
  display: flex;
  justify-content: space-between;
  .input-box{
    margin-right: 10px;
    input{
      width: 90%;
    }
  }
  .code-btn,.clock-btn{
    height: 40px;
    border-radius: 1px;
    font-size: 15px;
    color: #FFFFFF;
    padding: 10px 0px;
    white-space: nowrap;
    width: 45%;
    text-align: center;
  }
  .code-btn{
    background: #FF8622;
  }
  .clock-btn{
    background: #E1E1E1;
  }
}
.can-withdraw{
  padding-top: 10px;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
  span{
    color: #FF4F76;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/statistics/modal/Withdraw.vue